import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { MoveRight, TrendingDown, TrendingUp } from 'lucide-react';
import { ChildTooltip } from './ChildTooltip';

export const OrderTotalCard = ({
  title,
  subtitle,
  numberOfOrders,
  suffix,
  trend,
}: {
  title: string;
  subtitle: string;
  numberOfOrders: number;
  suffix?: string;
  trend?: number;
}) => {
  const getColor = (trend: number) => (trend < 0 ? 'text-red-500' : trend > 0 ? 'text-green-500' : 'text-orange-500');

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex justify-between items-center">
        <div>
          <p className="text-3xl font-bold">
            {numberOfOrders}
            {suffix ? <span className="text-xs ml-1">{suffix}</span> : ''}
          </p>
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        </div>
        {!trend ? (
          <></>
        ) : (
          <div className={`flex items-center ${getColor(trend)} self-start mt-1`}>
            {/* <span className="ml-1">{Math.abs(trend).toFixed(0)}%</span> */}
            {trend > 0 ? (
              <>
                <ChildTooltip title="More than previously">
                  <TrendingUp className="h-5 w-5" />
                </ChildTooltip>
              </>
            ) : trend < 0 ? (
              <>
                <ChildTooltip title="Less than previously">
                  <TrendingDown className="h-5 w-5" />
                </ChildTooltip>
              </>
            ) : (
              <>
                <ChildTooltip title="The same as previously">
                  <MoveRight className="h-5 w-5" />
                </ChildTooltip>
              </>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
